<template>
  <div class="page-box main-container">
    <Button type="primary" class="back-btn" @click="back()" v-if="showBack">返回</Button>
    <Tabs :value="activeTab" @on-click="change" :animated="false">
      <TabPane label="员工职级" name="0">
        <rankPage ref="rankPage"></rankPage>
      </TabPane>
      <TabPane label="职级变更记录" name="2">
        <historyPage ref="historyPage" :isShow="activeTab=='2'"></historyPage>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import rankPage from './components/rankPage'
import historyPage from './components/historyPage'
import editModal from './components/editModal'
export default {
  props: {},
  components: {
    editModal,
    historyPage,
    rankPage,
  },
  data() {
    return {
      loading: false,
      showBack: false,
      activeTab: '0',
    }
  },
  mounted() {
    this.showBack = this.$route.query.showBack;
    if(sessionStorage.promotionManage_tab){
      this.activeTab = sessionStorage.promotionManage_tab;
    }else{
      this.$refs.rankPage.init();
    }
    sessionStorage.removeItem('promotionManage_tab')
  },
  methods: {
    back(){
      window.parent.document.getElementById("iframe").contentWindow.postMessage({
        getRankList: true,
      }, '*');
      window.parent.postMessage({
        page: '',
        appMessage: true,
        openPage: true,
      }, '*');
    },
    //获取机构晋升达标员工列表
    change(tab) {
      this.activeTab = tab
      if (tab == '0') {
        this.$refs.rankPage && this.$refs.rankPage.init()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import './mechanism.scss';
</style>
